export const ACHIEVEMENT_STORAGE_KEY = "idiot2.achievements.v1";

export const ACHIEVEMENT_CATEGORIES = Object.freeze([
  "Cards played",
  "Hand achievements",
  "Setup",
  "2 / 10 achievements",
  "Four-of-kind / same-rank",
  "Chance card achievements",
  "Pickup / pain achievements",
  "End-game achievements",
  "Face-down achievements",
  "Win / loss achievements",
  "CPU achievements",
  "Games played",
  "Testing"
]);

export const ACHIEVEMENTS = Object.freeze([
  createAchievement("four-67-one-go", "67", "Play four of a kind 6666 and 7777 in one go.", {
    category: "Four-of-kind / same-rank",
    details: "Play all four 6s and all four 7s before the CPU gets a turn."
  }),
  createAchievement("hand-destinys-child", "Destiny’s Child", "Hold exactly three cards of the same rank in hand.", {
    category: "Hand achievements",
    details: "Your whole hand must be exactly three cards."
  }),
  createAchievement("hand-donald", "Donald", "Hold exactly 3, A, and 3 in hand.", {
    category: "Hand achievements",
    details: "Your whole hand must be exactly those three cards."
  }),
  createAchievement("hand-1337", "1337", "Hold exactly A, 3, 3, and 7 in hand.", {
    category: "Hand achievements",
    details: "Your whole hand must be exactly those four cards."
  }),
  createAchievement("setup-factory-settings", "Factory Settings", "Press Ready without changing your setup cards.", {
    category: "Setup"
  }),
  createAchievement("setup-extreme-makeover", "Extreme Makeover", "Swap all three hand cards with face-up cards before Ready.", {
    category: "Setup"
  }),
  createAchievement("setup-get-ready-for-this", "Get Ready for This", "Start with only 2s and 10s face-up.", {
    category: "Setup"
  }),
  createAchievement("setup-van-der-linde-plan", "Van der Linde Plan", "Start with three face-up cards of the same rank, except 2, 2, 2.", {
    category: "Setup",
    details: "The all-2s setup is excluded from this achievement."
  }),
  createAchievement("setup-lord-of-terror", "Lord of Terror", "Start with 6, 6, 6 face-up.", {
    category: "Setup"
  }),
  createAchievement("setup-royal-family", "Royal family", "Start with J, Q, and K face-up.", {
    category: "Setup"
  }),
  createAchievement("setup-entourage", "Entourage", "Start with an Ace and two 3s face-up.", {
    category: "Setup"
  }),
  createAchievement("setup-hank-moody", "Hank moody", "Start with only Queens face-up.", {
    category: "Setup"
  }),
  createAchievement("setup-lindsay-loadout", "Lindsay Loadout", "Start with three red cards face-up.", {
    category: "Setup"
  }),
  createAchievement("setup-two-brothers-on-the-forth-floor", "Two brothers on the forth floor", "Start with 2, 2, and 4 face-up.", {
    category: "Setup"
  }),
  createAchievement("setup-jackpot", "Jackpot", "Start with 7, 7, 7 face-up.", {
    category: "Setup"
  }),
  createAchievement("power-i-want-to-believe", "I Want to Believe", "Get all four 10s in one game.", {
    category: "2 / 10 achievements",
    details: "The 10s can be collected over time."
  }),
  createAchievement("power-there-is-no-spoon", "There is no spoon", "Play 25 cards in one uninterrupted human turn chain.", {
    category: "2 / 10 achievements",
    details: "The CPU must not get a turn between your first and 25th played cards."
  }),
  createAchievement("power-toivo-luck", "Toivo Luck", "Get all four 2s in one game.", {
    category: "2 / 10 achievements",
    details: "The 2s can be collected over time."
  }),
  createAchievement("power-jp-special", "JP Special", "Play all four 2s in one go and clear the wastepile.", {
    category: "2 / 10 achievements"
  }),
  createAchievement("power-170-binary-meltdown", "170: Binary Meltdown", "Play all four 10s in one turn chain.", {
    category: "2 / 10 achievements",
    details: "Each 10 must clear the wastepile; a different played card or a CPU turn resets the chain."
  }),
  createAchievement("power-ctrl-alt-delete", "Ctrl+Alt+Delete", "Clear a stack of at least 20 cards with a 10.", {
    category: "2 / 10 achievements"
  }),
  createAchievement("power-sandstorm", "Sandstorm", "Play both a 2 and a 10 in the same turn chain.", {
    category: "2 / 10 achievements"
  }),
  createAchievement("power-the-ringbearer", "The Ringbearer", "Play a starting-hand 2 or 10 as your final hand card.", {
    category: "2 / 10 achievements"
  }),
  createAchievement("power-svenskeknappen", "Svenskeknappen", "Play a 2 six or more times in one game.", {
    category: "2 / 10 achievements"
  }),
  createAchievement("four-fantastic-four", "Fantastic Four", "Clear the wastepile with four of a kind.", {
    category: "Four-of-kind / same-rank"
  }),
  createAchievement("four-know-when-to-stop", "Know When to Stop", "Skip a powerful same-rank continuation while you could still play it.", {
    category: "Four-of-kind / same-rank"
  }),
  createAchievement("four-ace-of-base", "Ace Of Base", "Get rid of all four Aces in one go.", {
    category: "Four-of-kind / same-rank"
  }),
  createAchievement("four-mata-hari", "Mata Hari", "Get rid of all four Queens in one go.", {
    category: "Four-of-kind / same-rank"
  }),
  createAchievement("four-bronco-4x4", "Bronco 4x4", "Clear the wastepile with four of a kind four times in a row.", {
    category: "Four-of-kind / same-rank",
    details: "Ordinary same-rank buildup plays are allowed between clears; a non-four clear, pickup, or CPU turn resets the streak."
  }),
  createAchievement("four-sneak-100", "Sneak 100", "Play the fourth card after the CPU plays the first three cards of a four-of-a-kind clear.", {
    category: "Four-of-kind / same-rank",
    details: "The CPU must play exactly three cards of that rank immediately before your clearing card."
  }),
  createAchievement("chance-bad-roll", "Bad Roll", "Draw a chance card and still pick up the wastepile.", {
    category: "Chance card achievements"
  }),
  createAchievement("chance-felix-felicis", "Felix Felicis", "Draw the card matching the wastepile's top rank to avoid pickup.", {
    category: "Chance card achievements",
    details: "You must have no legal move before drawing, and the chance card must match the wastepile's top rank. 2s and 10s do not count."
  }),
  createAchievement("chance-big-guy", "Big Guy", "Draw a successful chance card while already holding a legal 2 or 10.", {
    category: "Chance card achievements",
    details: "A forced pickup means the chance draw failed and does not count."
  }),
  createAchievement("chance-encounters-third-kind", "Get Lucky", "Use three successful chance cards in one uninterrupted human turn chain.", {
    category: "Chance card achievements",
    details: "Each chance card must avoid a wastepile pickup; a CPU turn resets the streak."
  }),
  createAchievement("chance-damn-im-lucky", "Damn, I’m Lucky", "Draw a 3 as a chance card and play it legally.", {
    category: "Chance card achievements"
  }),
  createAchievement("chance-needle-in-a-haystack", "Needle in a Haystack", "Clear the wastepile with four of a kind by playing the fourth card from a chance draw.", {
    category: "Chance card achievements",
    details: "The wastepile must already show the first three cards of that rank. Failed chance draws and ordinary played cards do not count."
  }),
  createAchievement("chance-take-a-chance-on-me", "Take a Chance on Me", "Win after only using chance cards while the draw deck has cards.", {
    category: "Chance card achievements",
    details: "During the draw-deck phase, only chance draws and their drawn cards may be played. Same-rank continuations must be skipped; normal play resumes once the draw deck is empty."
  }),
  createAchievement("pickup-leeroy-jenkins", "Leeroy Jenkins", "Pick up a wastepile with 20 or more cards.", {
    category: "Pickup / pain achievements"
  }),
  createAchievement("pickup-blue-screen-recovery", "Blue Screen Recovery", "Pick up a wastepile containing at least two 2s.", {
    category: "Pickup / pain achievements"
  }),
  createAchievement("pickup-loot-goblin", "Loot Goblin", "Pick up an all-high-card wastepile while you had a legal move.", {
    category: "Pickup / pain achievements"
  }),
  createAchievement("pickup-oceans-thirteen", "Ocean’s Thirteen", "Hold every rank in your hand at once.", {
    category: "Pickup / pain achievements",
    details: "Your hand must contain 3, 4, 5, 6, 7, 8, 9, J, Q, K, A, 2, and 10."
  }),
  createAchievement("pickup-the-brides-revenge", "The Bride’s Revenge", "Pick up the wastepile, then play a Queen on your next turn.", {
    category: "Pickup / pain achievements"
  }),
  createAchievement("pickup-ace-ventura", "Ace Ventura", "Pick up a wastepile containing only Aces.", {
    category: "Pickup / pain achievements"
  }),
  createAchievement("endgame-one-last-chest", "One Last Chest", "Pick up an all-high-card wastepile after the draw deck is empty.", {
    category: "End-game achievements",
    details: "Only an intentional human pickup counts. High cards are J, Q, K, A, and 2; 10 is excluded."
  }),
  createAchievement("facedown-this-is-fine", "This Is Fine", "Open a face-down 3.", {
    category: "Face-down achievements"
  }),
  createAchievement("facedown-thats-a-wrap-one-go", "That’s a Wrap", "Play all three face-down cards in one uninterrupted turn chain.", {
    category: "Face-down achievements",
    details: "Each starting face-down card must be opened and then played before the CPU gets a turn."
  }),
  createAchievement("facedown-everybody-hurts", "Everybody Hurts", "Open a face-down card and pick up 10 or more cards.", {
    category: "Face-down achievements"
  }),
  createAchievement("result-flatline-denied", "Flatline Denied", "Win while the opponent has only one card left.", {
    category: "Win / loss achievements"
  }),
  createAchievement("result-look-out-for-yourself", "Look Out for Yourself", "Win without picking up the stack.", {
    category: "Win / loss achievements"
  }),
  createAchievement("result-no-powers-no-problem", "No Powers, No Problem", "Win without playing a 2 or 10.", {
    category: "Win / loss achievements"
  }),
  createAchievement("result-almost-smart", "Almost Smart", "Lose while holding a 2 or 10.", {
    category: "Win / loss achievements"
  }),
  createAchievement("result-fru-toivo-special", "Fru Toivo Special", "Pick up 20 or more cards after the draw deck is empty, then still win.", {
    category: "Win / loss achievements"
  }),
  createAchievement("result-unicorn", "Unicorn", "Win with 3 as your last played card.", {
    category: "Win / loss achievements"
  }),
  createAchievement("result-domination", "Domination", "Win while the CPU still has 15 or more cards.", {
    category: "Win / loss achievements"
  }),
  createAchievement("result-im-thinking-im-back", "I’m Thinking I’m Back", "Win a revenge game.", {
    category: "Win / loss achievements"
  }),
  createAchievement("endgame-steamrolling", "Steamrolling", "Play all three face-up cards in one uninterrupted turn chain.", {
    category: "End-game achievements",
    details: "The CPU must not get a turn between the first and third face-up card. The cards may clear the wastepile or continue through 2s."
  }),
  createAchievement("result-underdog", "Underdog", "Win after pressing Ready with your three weakest setup cards face-up.", {
    category: "Win / loss achievements",
    details: "At Ready, every face-up card must be no stronger than every card kept in hand; 2 and 10 count as power cards."
  }),
  createAchievement("result-triple-platinum", "Triple Platinum", "Win 3 games in a row.", {
    category: "Win / loss achievements",
    target: 3,
    details: "Losses reset the streak. Starting a new game after the draw deck is empty while you still have cards also resets it."
  }),
  createAchievement("result-the-fifth-element", "The Fifth Element", "Win 5 games in a row.", {
    category: "Win / loss achievements",
    target: 5,
    details: "Losses reset the streak. Starting a new game after the draw deck is empty while you still have cards also resets it."
  }),
  createAchievement("result-godlike", "Godlike", "Win 10 games in a row.", {
    category: "Win / loss achievements",
    target: 10,
    details: "Losses reset the streak. Starting a new game after the draw deck is empty while you still have cards also resets it."
  }),
  createAchievement("cpu-386-bully", "386 Bully", "Beat Normal CPU.", {
    category: "CPU achievements"
  }),
  createAchievement("cpu-run-back", "Run Back", "Lose to Hard CPU.", {
    category: "CPU achievements"
  }),
  createAchievement("cpu-pentium-slayer", "Pentium Slayer", "Beat Hard CPU.", {
    category: "CPU achievements"
  }),
  createAchievement("cpu-aryas-list", "Arya’s List", "Beat both Normal CPU and Hard CPU without picking up cards from the wastepile.", {
    category: "CPU achievements",
    details: "This can take multiple games."
  }),
  createAchievement("cpu-commander-mean", "Commander Mean", "Force the CPU to pick up the wastepile five times in a row.", {
    category: "CPU achievements",
    details: "Only forced CPU pickups caused by your actions count; another pickup or any CPU action without that pickup resets the streak."
  }),
  createAchievement("games-100-sterling-performance", "100 Sterling Performance", "Complete 100 games.", {
    category: "Games played",
    target: 100
  }),
  createAchievement("games-200-summer-never-ends", "200 Summer Never Ends", "Complete 200 games.", {
    category: "Games played",
    target: 200
  }),
  createAchievement("games-500-just-one-more-job", "500 Just One More Job", "Complete 500 games.", {
    category: "Games played",
    target: 500
  }),
  createAchievement("games-1000-exalted-with-idiot", "1000 Exalted With Idiot", "Complete 1000 games.", {
    category: "Games played",
    target: 1000
  }),
  createAchievement("daily-quest-accepted", "Daily Quest Accepted", "Complete a game 3 days in a row.", {
    category: "Games played",
    target: 3,
    details: "Only the first completed game on a calendar day counts; skipping a day resets the streak."
  }),
  createAchievement("daily-oops-i-did-it-five-times", "Oops!... I Did It Five Times", "Complete a game 5 days in a row.", {
    category: "Games played",
    target: 5,
    details: "Only the first completed game on a calendar day counts; skipping a day resets the streak."
  }),
  createAchievement("daily-seven-nation-addiction", "Seven Nation Addiction", "Complete a game 7 days in a row.", {
    category: "Games played",
    target: 7,
    details: "Only the first completed game on a calendar day counts; skipping a day resets the streak."
  }),
  createAchievement("daily-i-know-what-you-did-last-month", "I Know What You Did Last Month", "Complete a game 30 days in a row.", {
    category: "Games played",
    target: 30,
    details: "Only the first completed game on a calendar day counts; skipping a day resets the streak."
  }),
  createAchievement("daily-this-is-my-life-now", "This Is My Life Now", "Complete a game 50 days in a row.", {
    category: "Games played",
    target: 50,
    details: "Only the first completed game on a calendar day counts; skipping a day resets the streak."
  }),
  createAchievement("test-any-card-played", "Any card played", "Play any card after arming the test trigger.", {
    category: "Testing",
    details: "Testing achievement triggered from the Achievements view.",
    testOnly: true
  })
]);

const ACHIEVEMENTS_BY_ID = new Map(ACHIEVEMENTS.map((achievement) => [achievement.id, achievement]));
const HIGH_CARD_RANKS = new Set(["J", "Q", "K", "A", "2"]);
const REQUIRED_ALL_RANKS = ["3", "4", "5", "6", "7", "8", "9", "J", "Q", "K", "A", "2", "10"];
const POWER_RANKS = new Set(["2", "10"]);
const POWER_OR_HIGH_SAME_RANKS = new Set(["J", "Q", "K", "A"]);
const RED_SUITS = new Set(["Hearts", "Diamonds"]);
const GAME_MILESTONES = [
  { id: "games-100-sterling-performance", count: 100 },
  { id: "games-200-summer-never-ends", count: 200 },
  { id: "games-500-just-one-more-job", count: 500 },
  { id: "games-1000-exalted-with-idiot", count: 1000 }
];
const WIN_STREAK_MILESTONES = [
  { id: "result-triple-platinum", count: 3 },
  { id: "result-the-fifth-element", count: 5 },
  { id: "result-godlike", count: 10 }
];
const WIN_STREAK_ACHIEVEMENT_IDS = new Set(WIN_STREAK_MILESTONES.map((milestone) => milestone.id));
const DAILY_STREAK_MILESTONES = [
  { id: "daily-quest-accepted", count: 3 },
  { id: "daily-oops-i-did-it-five-times", count: 5 },
  { id: "daily-seven-nation-addiction", count: 7 },
  { id: "daily-i-know-what-you-did-last-month", count: 30 },
  { id: "daily-this-is-my-life-now", count: 50 }
];
const DAILY_STREAK_ACHIEVEMENT_IDS = new Set(DAILY_STREAK_MILESTONES.map((milestone) => milestone.id));
const COMMANDER_MEAN_FORCED_CPU_PICKUP_TARGET = 5;
const ACHIEVEMENT_67_ID = "four-67-one-go";
const ACHIEVEMENT_67_RANKS = new Set(["6", "7"]);
const MS_PER_DAY = 24 * 60 * 60 * 1000;
const EMPTY_STORED_GAME_LOG = Object.freeze({
  savedAt: null,
  events: Object.freeze([])
});

function createAchievement(id, title, summary, options = {}) {
  return Object.freeze({
    id,
    title,
    summary,
    details: options.details ?? "",
    category: options.category ?? "General",
    target: options.target ?? null,
    testOnly: Boolean(options.testOnly)
  });
}

export function getAchievementById(id) {
  return ACHIEVEMENTS_BY_ID.get(id) ?? null;
}

export function createDefaultAchievementProgress() {
  return {
    version: 1,
    unlocked: {},
    aggregate: {
      gamesPlayed: 0,
      winStreak: 0,
      bestWinStreak: 0,
      dailyStreak: 0,
      bestDailyStreak: 0,
      lastCompletedGameDate: null,
      cleanWins: {
        normal: false,
        hard: false
      }
    }
  };
}

function normalizeGamesPlayedCount(value) {
  return Math.max(0, Number.parseInt(value ?? 0, 10) || 0);
}

function normalizeWinStreakCount(value) {
  return Math.max(0, Number.parseInt(value ?? 0, 10) || 0);
}

function normalizeDailyStreakCount(value) {
  return Math.max(0, Number.parseInt(value ?? 0, 10) || 0);
}

function normalizeCalendarDateKey(value) {
  return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : null;
}

function getHighestUnlockedMilestoneCount(unlocked, milestones) {
  let highest = 0;
  for (const milestone of milestones) {
    if (unlocked[milestone.id]) {
      highest = Math.max(highest, milestone.count);
    }
  }
  return highest;
}

export function normalizeAchievementProgress(value) {
  const defaults = createDefaultAchievementProgress();
  if (!value || typeof value !== "object") {
    return defaults;
  }

  const unlocked = {};
  if (value.unlocked && typeof value.unlocked === "object") {
    for (const [id, record] of Object.entries(value.unlocked)) {
      if (!ACHIEVEMENTS_BY_ID.has(id) || !record || typeof record !== "object") {
        continue;
      }
      unlocked[id] = {
        id,
        unlockedAt: typeof record.unlockedAt === "string" ? record.unlockedAt : new Date(0).toISOString(),
        category: typeof record.category === "string" ? record.category : getAchievementById(id)?.category ?? "",
        gameLog: createEmptyStoredGameLog(),
        pendingGameId: null
      };
    }
  }

  const winStreak = normalizeWinStreakCount(value.aggregate?.winStreak);
  const bestWinStreak = Math.max(
    winStreak,
    normalizeWinStreakCount(value.aggregate?.bestWinStreak),
    getHighestUnlockedMilestoneCount(unlocked, WIN_STREAK_MILESTONES)
  );
  const dailyStreak = normalizeDailyStreakCount(value.aggregate?.dailyStreak);
  const bestDailyStreak = Math.max(
    dailyStreak,
    normalizeDailyStreakCount(value.aggregate?.bestDailyStreak),
    getHighestUnlockedMilestoneCount(unlocked, DAILY_STREAK_MILESTONES)
  );

  return {
    version: 1,
    unlocked,
    aggregate: {
      gamesPlayed: Math.max(0, Number.parseInt(value.aggregate?.gamesPlayed ?? 0, 10) || 0),
      winStreak,
      bestWinStreak,
      dailyStreak,
      bestDailyStreak,
      lastCompletedGameDate: normalizeCalendarDateKey(value.aggregate?.lastCompletedGameDate),
      cleanWins: {
        normal: Boolean(value.aggregate?.cleanWins?.normal),
        hard: Boolean(value.aggregate?.cleanWins?.hard)
      }
    }
  };
}

export function readAchievementProgress(storage) {
  if (!storage) {
    return createDefaultAchievementProgress();
  }

  let raw = null;
  try {
    raw = storage.getItem(ACHIEVEMENT_STORAGE_KEY);
  } catch {
    return createDefaultAchievementProgress();
  }
  if (!raw) {
    return createDefaultAchievementProgress();
  }

  try {
    const normalized = normalizeAchievementProgress(JSON.parse(raw));
    try {
      persistNormalizedAchievementProgress(storage, normalized, { expectedRaw: raw });
    } catch {
      // Keep the parsed progress even if the best-effort log purge cannot be written yet.
    }
    return normalized;
  } catch {
    return createDefaultAchievementProgress();
  }
}

export function persistAchievementProgress(storage, progress) {
  if (!storage) {
    return false;
  }

  try {
    return persistNormalizedAchievementProgress(storage, normalizeAchievementProgress(progress));
  } catch {
    return false;
  }
}

export function createAchievementRuntime() {
  return createEmptyAchievementRuntime();
}

export function beginAchievementGame(runtime, state, options = {}) {
  const nextSequence = (runtime?.nextGameSequence ?? 1) + 1;
  Object.assign(runtime, createEmptyAchievementRuntime());
  runtime.nextGameSequence = nextSequence;
  runtime.gameId = options.gameId ?? `game-${nextSequence}`;
  runtime.humanName = getHumanPlayerSnapshot(state)?.name ?? null;
  runtime.started = true;
  runtime.testAnyCardAchievementArmed = Boolean(options.testAnyCardAchievementArmed);

  const human = getHumanPlayerSnapshot(state);
  if (human) {
    runtime.initialHandIds = new Set(human.hand.map(getCardId).filter(Boolean));
    runtime.initialFaceUpIds = new Set(human.faceUp.map(getCardId).filter(Boolean));
    runtime.initialFaceDownCards = human.faceDown.map(copyAchievementCard);
    runtime.initialFaceDownIds = new Set(runtime.initialFaceDownCards.map(getCardId).filter(Boolean));
    setSteamrollingTargets(runtime, human);
  }

  observeHumanVisiblePowerCards(runtime, state);
  return runtime;
}

export function noteAchievementSetupSwap(runtime) {
  if (runtime) {
    runtime.setupSwapCount += 1;
  }
}

export function evaluateAchievementState(runtime, progress, state, options = {}) {
  if (!runtime?.started) {
    return [];
  }

  const unlocks = [];
  const human = getHumanPlayerSnapshot(state);
  if (!human) {
    return unlocks;
  }

  observeHumanVisiblePowerCards(runtime, state);
  unlockHandAchievements(runtime, progress, human, unlocks, options);
  unlockVisiblePowerCollectionAchievements(runtime, progress, unlocks, options);
  return unlocks;
}

export function processAchievementReady(runtime, progress, state, options = {}) {
  if (!runtime?.started) {
    return [];
  }

  const unlocks = evaluateAchievementState(runtime, progress, state, options);
  const human = getHumanPlayerSnapshot(state);
  if (!human) {
    return unlocks;
  }

  const faceUpRanks = human.faceUp.map((card) => card.rank);
  const faceUpRankCounts = countRanks(human.faceUp);

  if (runtime.setupSwapCount === 0) {
    pushUnlock(runtime, progress, unlocks, "setup-factory-settings", options);
  }
  if (
    runtime.initialHandIds.size === 3
    && runtime.initialFaceUpIds.size === 3
    && human.faceUp.every((card) => runtime.initialHandIds.has(card.id))
    && human.hand.every((card) => runtime.initialFaceUpIds.has(card.id))
  ) {
    pushUnlock(runtime, progress, unlocks, "setup-extreme-makeover", options);
  }
  if (human.faceUp.length === 3 && human.faceUp.every((card) => POWER_RANKS.has(card.rank))) {
    pushUnlock(runtime, progress, unlocks, "setup-get-ready-for-this", options);
  }
  const faceUpTripleRank = human.faceUp.length === 3
    ? [...faceUpRankCounts.entries()].find(([, count]) => count === 3)?.[0] ?? null
    : null;
  if (faceUpTripleRank && faceUpTripleRank !== "2") {
    pushUnlock(runtime, progress, unlocks, "setup-van-der-linde-plan", options);
  }
  if (hasExactRanks(faceUpRanks, ["6", "6", "6"])) {
    pushUnlock(runtime, progress, unlocks, "setup-lord-of-terror", options);
  }
  if (hasExactRanks(faceUpRanks, ["J", "Q", "K"])) {
    pushUnlock(runtime, progress, unlocks, "setup-royal-family", options);
  }
  if (hasExactRanks(faceUpRanks, ["A", "3", "3"])) {
    pushUnlock(runtime, progress, unlocks, "setup-entourage", options);
  }
  if (hasExactRanks(faceUpRanks, ["Q", "Q", "Q"])) {
    pushUnlock(runtime, progress, unlocks, "setup-hank-moody", options);
  }
  if (human.faceUp.length === 3 && human.faceUp.every((card) => RED_SUITS.has(card.suit))) {
    pushUnlock(runtime, progress, unlocks, "setup-lindsay-loadout", options);
  }
  if (hasExactRanks(faceUpRanks, ["2", "2", "4"])) {
    pushUnlock(runtime, progress, unlocks, "setup-two-brothers-on-the-forth-floor", options);
  }
  if (hasExactRanks(faceUpRanks, ["7", "7", "7"])) {
    pushUnlock(runtime, progress, unlocks, "setup-jackpot", options);
  }

  runtime.underdogReadySetup = hasUnderdogReadySetup(human);
  runtime.startingHandPowerIds = new Set(
    human.hand.filter((card) => POWER_RANKS.has(card.rank)).map((card) => card.id)
  );
  setSteamrollingTargets(runtime, human);
  return unlocks;
}

export function processAchievementAction(runtime, progress, actionEvent, options = {}) {
  if (!runtime?.started || !actionEvent?.after) {
    return [];
  }

  const unlocks = [];
  const event = normalizeActionEvent(actionEvent);
  const humanName = runtime.humanName;
  const humanEvent = event.playerName === humanName;

  if (event.wastePickup?.playerName === humanName) {
    processHumanWastePickup(runtime, progress, event, unlocks, options);
  }

  if (humanEvent) {
    processHumanAction(runtime, progress, event, unlocks, options);
  } else if (event.playerRole === "cpu") {
    processCpuAction(runtime, event);
    endHumanTurnChain(runtime);
  }
  processForcedCpuPickupStreak(runtime, progress, event, unlocks, options);

  evaluateAchievementState(runtime, progress, event.after, options)
    .forEach((unlock) => unlocks.push(unlock));

  if (humanEvent && event.after.currentPlayerName !== humanName) {
    endHumanTurnChain(runtime);
  }

  return unlocks;
}

export function processAchievementNewGameStart(runtime, progress, state) {
  if (!runtime?.started || !progress?.aggregate) {
    return false;
  }

  const human = getHumanPlayerSnapshot(state);
  if (!human || human.status === "Winner") {
    return false;
  }

  if (getDrawDeckCount(state) !== 0 || countTotalCards(human) === 0) {
    return false;
  }

  return resetAchievementWinStreak(progress);
}

export function completeAchievementGame(runtime, progress, state, options = {}) {
  if (!runtime?.started || runtime.completed) {
    return [];
  }

  const unlocks = [];
  const human = getHumanPlayerSnapshot(state);
  if (!human || (human.status !== "Winner" && human.status !== "Idiot")) {
    return unlocks;
  }

  runtime.completed = true;
  evaluateAchievementState(runtime, progress, state, options)
    .forEach((unlock) => unlocks.push(unlock));

  const cpu = getCpuPlayerSnapshot(state);
  const difficulty = cpu?.cpuDifficulty === "hard" ? "hard" : "normal";
  const won = human.status === "Winner";
  const countForStatistics = options.countForStatistics !== false;
  const isRevenge = options.isRevenge === true;

  unlockGamesPlayedAchievements(runtime, progress, options.gamesPlayed, options)
    .forEach((unlock) => unlocks.push(unlock));

  if (countForStatistics) {
    const dailyStreak = updateAchievementDailyStreak(progress, options.now);
    if (dailyStreak.counted) {
      unlockDailyStreakAchievements(runtime, progress, dailyStreak.count, options)
        .forEach((unlock) => unlocks.push(unlock));
    }
  }

  if (won) {
    if (countForStatistics) {
      const winStreak = incrementAchievementWinStreak(progress);
      unlockWinStreakAchievements(runtime, progress, winStreak, options)
        .forEach((unlock) => unlocks.push(unlock));
    }

    if (countTotalCards(cpu) === 1) {
      pushUnlock(runtime, progress, unlocks, "result-flatline-denied", options);
    }
    if (!runtime.pickedUpWastepile) {
      pushUnlock(runtime, progress, unlocks, "result-look-out-for-yourself", options);
      progress.aggregate.cleanWins[difficulty] = true;
    }
    if (!runtime.playedPowerCard) {
      pushUnlock(runtime, progress, unlocks, "result-no-powers-no-problem", options);
    }
    if (runtime.hadDeckEmptyLargePickup) {
      pushUnlock(runtime, progress, unlocks, "result-fru-toivo-special", options);
    }
    if (runtime.lastHumanPlayedRank === "3") {
      pushUnlock(runtime, progress, unlocks, "result-unicorn", options);
    }
    if (countTotalCards(cpu) >= 15) {
      pushUnlock(runtime, progress, unlocks, "result-domination", options);
    }
    if (isRevenge) {
      pushUnlock(runtime, progress, unlocks, "result-im-thinking-im-back", options);
    }
    if (runtime.underdogReadySetup) {
      pushUnlock(runtime, progress, unlocks, "result-underdog", options);
    }
    if (runtime.takeChanceOnMeEligible && runtime.takeChanceOnMeUsedChanceDraw) {
      pushUnlock(runtime, progress, unlocks, "chance-take-a-chance-on-me", options);
    }
    pushUnlock(runtime, progress, unlocks, difficulty === "hard" ? "cpu-pentium-slayer" : "cpu-386-bully", options);
    if (progress.aggregate.cleanWins.normal && progress.aggregate.cleanWins.hard) {
      pushUnlock(runtime, progress, unlocks, "cpu-aryas-list", options);
    }
  } else {
    if (countForStatistics) {
      resetAchievementWinStreak(progress);
    }

    if (human.hand.some((card) => POWER_RANKS.has(card.rank))) {
      pushUnlock(runtime, progress, unlocks, "result-almost-smart", options);
    }
    if (difficulty === "hard") {
      pushUnlock(runtime, progress, unlocks, "cpu-run-back", options);
    }
  }

  return unlocks;
}

export function unlockGamesPlayedAchievements(runtime, progress, gamesPlayed, options = {}) {
  const unlocks = [];
  const normalizedGamesPlayed = normalizeGamesPlayedCount(gamesPlayed);
  for (const milestone of GAME_MILESTONES) {
    if (normalizedGamesPlayed >= milestone.count) {
      pushUnlock(runtime, progress, unlocks, milestone.id, options);
    }
  }
  return unlocks;
}

export function unlockWinStreakAchievements(runtime, progress, winStreak, options = {}) {
  const unlocks = [];
  const normalizedWinStreak = normalizeWinStreakCount(winStreak);
  for (const milestone of WIN_STREAK_MILESTONES) {
    if (normalizedWinStreak >= milestone.count) {
      pushUnlock(runtime, progress, unlocks, milestone.id, options);
    }
  }
  return unlocks;
}

function unlockDailyStreakAchievements(runtime, progress, dailyStreak, options = {}) {
  const unlocks = [];
  const normalizedDailyStreak = normalizeDailyStreakCount(dailyStreak);
  for (const milestone of DAILY_STREAK_MILESTONES) {
    if (normalizedDailyStreak >= milestone.count) {
      pushUnlock(runtime, progress, unlocks, milestone.id, options);
    }
  }
  return unlocks;
}

export function attachPendingAchievementGameLogs(progress, gameId, _gameLog) {
  if (!progress?.unlocked || !gameId) {
    return false;
  }

  let changed = false;
  for (const record of Object.values(progress.unlocked)) {
    const hasPendingLog = record.pendingGameId === gameId;
    const hasStoredEvents = Array.isArray(record.gameLog?.events) && record.gameLog.events.length > 0;
    if (!hasPendingLog && !hasStoredEvents) {
      continue;
    }
    record.gameLog = createEmptyStoredGameLog();
    record.pendingGameId = null;
    changed = true;
  }
  return changed;
}

export function getAchievementStats(progress, options = {}) {
  const normalized = normalizeAchievementProgress(progress);
  const gamesPlayed = normalizeGamesPlayedCount(options.gamesPlayed);
  const achievements = options.includeTestOnly
    ? ACHIEVEMENTS
    : ACHIEVEMENTS.filter((achievement) => !achievement.testOnly);
  const unlockedCount = achievements.reduce(
    (count, achievement) => count + (normalized.unlocked[achievement.id] ? 1 : 0),
    0
  );
  return {
    unlockedCount,
    totalCount: achievements.length,
    gamesPlayed
  };
}

export function getAchievementStreakStats(progress, options = {}) {
  const normalized = normalizeAchievementProgress(progress);
  const daily = {
    current: normalized.aggregate.dailyStreak,
    best: normalized.aggregate.bestDailyStreak
  };
  if (options.includeToday) {
    daily.playedToday = normalized.aggregate.lastCompletedGameDate === getLocalCalendarDateKey(options.now);
  }
  return {
    daily,
    win: {
      current: normalized.aggregate.winStreak,
      best: normalized.aggregate.bestWinStreak
    }
  };
}

export function getAchievementProgressValue(achievement, progress, options = {}) {
  if (!achievement?.target) {
    return null;
  }

  if (WIN_STREAK_ACHIEVEMENT_IDS.has(achievement.id)) {
    const normalized = normalizeAchievementProgress(progress);
    return {
      value: Math.min(normalized.aggregate.winStreak, achievement.target),
      target: achievement.target
    };
  }

  if (DAILY_STREAK_ACHIEVEMENT_IDS.has(achievement.id)) {
    const normalized = normalizeAchievementProgress(progress);
    return {
      value: Math.min(normalized.aggregate.dailyStreak, achievement.target),
      target: achievement.target
    };
  }

  const gamesPlayed = normalizeGamesPlayedCount(options.gamesPlayed);
  return {
    value: Math.min(gamesPlayed, achievement.target),
    target: achievement.target
  };
}

export function createStoredGameLog(_events) {
  return createEmptyStoredGameLog();
}

function createEmptyAchievementRuntime() {
  return {
    gameId: null,
    nextGameSequence: 1,
    started: false,
    completed: false,
    humanName: null,
    setupSwapCount: 0,
    initialHandIds: new Set(),
    initialFaceUpIds: new Set(),
    initialFaceDownCards: [],
    initialFaceDownIds: new Set(),
    visibleFaceDownIds: new Set(),
    openedFaceDownIdsInTurnChain: new Set(),
    playedFaceDownIdsInTurnChain: new Set(),
    steamrollingFaceUpTargetIds: new Set(),
    steamrollingFaceUpPlayedIds: new Set(),
    startingHandPowerIds: new Set(),
    visiblePowerCardIdsByRank: {
      "2": new Set(),
      "10": new Set()
    },
    humanTurnChainActive: false,
    humanTurnChainPlayedRanks: new Set(),
    humanTurnChainPlayedCardCount: 0,
    consecutiveRank: null,
    consecutiveRankCount: 0,
    binaryMeltdownTenStreak: 0,
    fourKindClearStreak: 0,
    fourKind67RanksInTurnChain: new Set(),
    sneak100CpuTurnRank: null,
    sneak100CpuTurnCardCount: 0,
    sneak100CpuSetupRank: null,
    twoPlayCount: 0,
    pickedUpWastepile: false,
    playedPowerCard: false,
    lastHumanPlayedRank: null,
    lastChanceCardId: null,
    successfulChanceDrawStreak: 0,
    takeChanceOnMeEligible: true,
    takeChanceOnMeUsedChanceDraw: false,
    takeChanceOnMePendingCardId: null,
    bridePending: false,
    hadDeckEmptyLargePickup: false,
    underdogReadySetup: false,
    forcedCpuPickupStreak: 0,
    testAnyCardAchievementArmed: false,
    testAnyCardAchievementTriggered: false
  };
}

function normalizeActionEvent(event) {
  return {
    type: event.type,
    playerName: event.playerName,
    playerRole: event.playerRole,
    sourceZone: event.sourceZone ?? null,
    card: copyAchievementCard(event.card),
    achievement: copyAchievementEvent(event.achievement),
    wastePickup: event.wastePickup ? {
      playerName: event.wastePickup.playerName,
      cardCount: event.wastePickup.cardCount,
      forced: Boolean(event.wastePickup.forced),
      cards: Array.isArray(event.wastePickup.cards) ? event.wastePickup.cards.map(copyAchievementCard).filter(Boolean) : []
    } : null,
    before: event.before,
    after: event.after
  };
}

function processHumanAction(runtime, progress, event, unlocks, options) {
  trackTakeChanceOnMeAction(runtime, event);
  switch (event.type) {
    case "playCard":
      processHumanPlayCard(runtime, progress, event, unlocks, options);
      return;
    case "drawChanceCard":
      processHumanChanceDraw(runtime, progress, event, unlocks, options);
      return;
    case "openFaceDownCard":
      processHumanOpenFaceDown(runtime, progress, event, unlocks, options);
      return;
    case "skipSameRank":
      processHumanSkipSameRank(runtime, progress, event, unlocks, options);
      return;
    case "pickUpWastepile":
    case "pass":
      clearSneak100CpuSetup(runtime);
      return;
    default:
      return;
  }
}

function processCpuAction(runtime, event) {
  if (event.type === "playCard") {
    trackSneak100CpuPlay(runtime, event);
    return;
  }

  if (event.type === "skipSameRank" || event.type === "pass") {
    maybeFinalizeSneak100CpuSetup(runtime, event);
    resetSneak100CpuTurn(runtime);
    return;
  }

  clearSneak100CpuSetup(runtime);
  resetSneak100CpuTurn(runtime);
}

function processForcedCpuPickupStreak(runtime, progress, event, unlocks, options) {
  if (didHumanForceCpuWastePickup(runtime, event)) {
    runtime.forcedCpuPickupStreak += 1;
    if (runtime.forcedCpuPickupStreak >= COMMANDER_MEAN_FORCED_CPU_PICKUP_TARGET) {
      pushUnlock(runtime, progress, unlocks, "cpu-commander-mean", options);
    }
    return;
  }

  if (doesActionBreakForcedCpuPickupStreak(event)) {
    runtime.forcedCpuPickupStreak = 0;
  }
}

function didHumanForceCpuWastePickup(runtime, event) {
  if (event.playerName !== runtime.humanName || !event.wastePickup?.forced) {
    return false;
  }

  const pickupPlayerName = event.wastePickup.playerName;
  if (!pickupPlayerName || pickupPlayerName === runtime.humanName) {
    return false;
  }

  const pickupPlayer = findSnapshotPlayer(event.after, pickupPlayerName)
    ?? findSnapshotPlayer(event.before, pickupPlayerName);
  return pickupPlayer?.role === "cpu";
}

function doesActionBreakForcedCpuPickupStreak(event) {
  return Boolean(event.wastePickup || event.playerRole === "cpu");
}

function trackTakeChanceOnMeAction(runtime, event) {
  if (!runtime.takeChanceOnMeEligible || getDrawDeckCount(event.before) === 0) {
    return;
  }

  if (event.type === "drawChanceCard") {
    runtime.takeChanceOnMeUsedChanceDraw = true;
    runtime.takeChanceOnMePendingCardId = event.wastePickup ? null : (event.card?.id ?? null);
    return;
  }

  if (event.type === "playCard") {
    const playedPendingChanceCard = Boolean(
      runtime.takeChanceOnMePendingCardId
      && event.card?.id === runtime.takeChanceOnMePendingCardId
    );
    if (playedPendingChanceCard) {
      runtime.takeChanceOnMePendingCardId = null;
      return;
    }
  }

  if (event.type === "skipSameRank") {
    return;
  }

  runtime.takeChanceOnMeEligible = false;
  runtime.takeChanceOnMePendingCardId = null;
}

function processHumanPlayCard(runtime, progress, event, unlocks, options) {
  const card = event.card;
  if (!card?.rank) {
    return;
  }

  startHumanTurnChain(runtime);
  trackSteamrollingPlay(runtime, event);
  trackFaceDownWrapPlay(runtime, event);
  if (runtime.testAnyCardAchievementArmed && !runtime.testAnyCardAchievementTriggered) {
    runtime.testAnyCardAchievementTriggered = true;
    runtime.testAnyCardAchievementArmed = false;
    pushUnlock(runtime, progress, unlocks, "test-any-card-played", options);
  }

  runtime.humanTurnChainPlayedRanks.add(card.rank);
  runtime.humanTurnChainPlayedCardCount += 1;
  if (runtime.humanTurnChainPlayedCardCount >= 25) {
    pushUnlock(runtime, progress, unlocks, "power-there-is-no-spoon", options);
  }
  if (runtime.humanTurnChainPlayedRanks.has("2") && runtime.humanTurnChainPlayedRanks.has("10")) {
    pushUnlock(runtime, progress, unlocks, "power-sandstorm", options);
  }

  runtime.consecutiveRankCount = runtime.consecutiveRank === card.rank
    ? runtime.consecutiveRankCount + 1
    : 1;
  runtime.consecutiveRank = card.rank;
  runtime.lastHumanPlayedRank = card.rank;

  if (POWER_RANKS.has(card.rank)) {
    runtime.playedPowerCard = true;
  }
  if (card.rank === "2") {
    runtime.twoPlayCount += 1;
    if (runtime.twoPlayCount >= 6) {
      pushUnlock(runtime, progress, unlocks, "power-svenskeknappen", options);
    }
  }
  if (runtime.bridePending) {
    if (card.rank === "Q") {
      pushUnlock(runtime, progress, unlocks, "pickup-the-brides-revenge", options);
    }
    runtime.bridePending = false;
  }
  let playedPendingChanceCard = false;
  if (runtime.lastChanceCardId && runtime.lastChanceCardId === card.id) {
    playedPendingChanceCard = true;
    if (card.rank === "3") {
      pushUnlock(runtime, progress, unlocks, "chance-damn-im-lucky", options);
    }
    runtime.lastChanceCardId = null;
  }
  if (card.rank === "10" && event.after.playStack?.length === 0) {
    runtime.binaryMeltdownTenStreak += 1;
    if (runtime.binaryMeltdownTenStreak >= 4) {
      pushUnlock(runtime, progress, unlocks, "power-170-binary-meltdown", options);
    }
  } else {
    runtime.binaryMeltdownTenStreak = 0;
  }

  const fourKindClear = didHumanCauseFourKindClear(event);
  if (fourKindClear) {
    pushUnlock(runtime, progress, unlocks, "four-fantastic-four", options);
    if (playedPendingChanceCard) {
      pushUnlock(runtime, progress, unlocks, "chance-needle-in-a-haystack", options);
    }
    if (didHumanStealCpuFourKindClear(runtime, event)) {
      pushUnlock(runtime, progress, unlocks, "four-sneak-100", options);
    }
    runtime.fourKindClearStreak += 1;
    if (runtime.fourKindClearStreak >= 4) {
      pushUnlock(runtime, progress, unlocks, "four-bronco-4x4", options);
    }
    if (card.rank === "2" && runtime.consecutiveRankCount >= 4) {
      pushUnlock(runtime, progress, unlocks, "power-jp-special", options);
    }
    if (card.rank === "A" && runtime.consecutiveRankCount >= 4) {
      pushUnlock(runtime, progress, unlocks, "four-ace-of-base", options);
    }
    if (card.rank === "Q" && runtime.consecutiveRankCount >= 4) {
      pushUnlock(runtime, progress, unlocks, "four-mata-hari", options);
    }
    if (ACHIEVEMENT_67_RANKS.has(card.rank) && runtime.consecutiveRankCount >= 4) {
      runtime.fourKind67RanksInTurnChain.add(card.rank);
      if (runtime.fourKind67RanksInTurnChain.size === ACHIEVEMENT_67_RANKS.size) {
        pushUnlock(runtime, progress, unlocks, ACHIEVEMENT_67_ID, options);
      }
    }
  } else if (event.after.playStack?.length === 0) {
    runtime.fourKindClearStreak = 0;
  }
  clearSneak100CpuSetup(runtime);

  if (card.rank === "10" && (event.before.playStack?.length ?? 0) + 1 >= 20 && event.after.playStack?.length === 0) {
    pushUnlock(runtime, progress, unlocks, "power-ctrl-alt-delete", options);
  }

  const beforeHuman = findSnapshotHuman(event.before, runtime.humanName);
  const afterHuman = findSnapshotHuman(event.after, runtime.humanName);
  if (
    event.sourceZone === "hand"
    && POWER_RANKS.has(card.rank)
    && runtime.startingHandPowerIds.has(card.id)
    && beforeHuman?.hand?.length === 1
    && afterHuman?.hand?.length === 0
    && (afterHuman?.faceUp?.length ?? 0) > 0
  ) {
    pushUnlock(runtime, progress, unlocks, "power-the-ringbearer", options);
  }

  if (hasCompleteSteamrollingChain(runtime)) {
    pushUnlock(runtime, progress, unlocks, "endgame-steamrolling", options);
  }
  if (hasCompleteFaceDownWrapChain(runtime)) {
    pushUnlock(runtime, progress, unlocks, "facedown-thats-a-wrap-one-go", options);
  }
}

function processHumanChanceDraw(runtime, progress, event, unlocks, options) {
  const card = event.card;
  const beforeHuman = findSnapshotHuman(event.before, runtime.humanName);
  if (!card) {
    return;
  }

  runtime.lastChanceCardId = event.wastePickup ? null : (card.id ?? null);
  if (event.wastePickup) {
    resetChanceDrawStreak(runtime);
    if (event.wastePickup.playerName === runtime.humanName) {
      pushUnlock(runtime, progress, unlocks, "chance-bad-roll", options);
    }
  } else {
    runtime.successfulChanceDrawStreak += 1;
    if (runtime.successfulChanceDrawStreak >= 3) {
      pushUnlock(runtime, progress, unlocks, "chance-encounters-third-kind", options);
    }
  }

  const legalMovesBefore = getValidCardsForSnapshot(event.before, beforeHuman);
  const legalPowerInHand = beforeHuman?.hand?.some((candidate) => (
    POWER_RANKS.has(candidate.rank) && isCardLegalInSnapshot(event.before, beforeHuman, candidate)
  ));
  if (legalPowerInHand && !event.wastePickup) {
    pushUnlock(runtime, progress, unlocks, "chance-big-guy", options);
  }

  const topCard = event.before.playStack?.[0] ?? null;
  const afterHuman = findSnapshotHuman(event.after, runtime.humanName);
  if (
    legalMovesBefore.length === 0
    && topCard?.rank
    && card.rank === topCard.rank
    && !POWER_RANKS.has(card.rank)
    && !event.wastePickup
    && isCardLegalInSnapshot(event.after, afterHuman, card)
  ) {
    pushUnlock(runtime, progress, unlocks, "chance-felix-felicis", options);
  }
}

function processHumanOpenFaceDown(runtime, progress, event, unlocks, options) {
  const card = event.card;
  if (!card) {
    return;
  }

  if (card.id) {
    runtime.visibleFaceDownIds.add(card.id);
    if (runtime.initialFaceDownIds.has(card.id)) {
      runtime.openedFaceDownIdsInTurnChain.add(card.id);
    }
  }
  if (card.rank === "3") {
    pushUnlock(runtime, progress, unlocks, "facedown-this-is-fine", options);
  }
  if (event.wastePickup?.playerName === runtime.humanName && event.wastePickup.cardCount >= 10) {
    pushUnlock(runtime, progress, unlocks, "facedown-everybody-hurts", options);
  }
}

function processHumanSkipSameRank(runtime, progress, event, unlocks, options) {
  const topRank = event.before.playStack?.[0]?.rank ?? null;
  const beforeHuman = findSnapshotHuman(event.before, runtime.humanName);
  if (
    event.before.nextCardMustBeSameRank
    && POWER_OR_HIGH_SAME_RANKS.has(topRank)
    && getActiveZoneCards(beforeHuman).some((card) => card.rank === topRank)
  ) {
    pushUnlock(runtime, progress, unlocks, "four-know-when-to-stop", options);
  }
}

function processHumanWastePickup(runtime, progress, event, unlocks, options) {
  const wastePickup = event.wastePickup;
  if (
    wastePickup?.cardCount >= 10
    && didHumanHoldOpenedFaceDownCard(runtime, event.before)
  ) {
    pushUnlock(runtime, progress, unlocks, "facedown-everybody-hurts", options);
  }
  if (!wastePickup?.cards?.length) {
    return;
  }

  clearSneak100CpuSetup(runtime);
  runtime.pickedUpWastepile = true;
  runtime.lastChanceCardId = null;
  resetChanceDrawStreak(runtime);
  runtime.bridePending = true;

  if (wastePickup.cardCount >= 20) {
    pushUnlock(runtime, progress, unlocks, "pickup-leeroy-jenkins", options);
    if ((event.before.deckCount ?? 0) === 0) {
      runtime.hadDeckEmptyLargePickup = true;
    }
  }
  if (countRank(wastePickup.cards, "2") >= 2) {
    pushUnlock(runtime, progress, unlocks, "pickup-blue-screen-recovery", options);
  }
  if (wastePickup.cards.every((card) => HIGH_CARD_RANKS.has(card.rank))) {
    const intentionalHumanPickup = event.type === "pickUpWastepile"
      && event.playerName === runtime.humanName
      && !wastePickup.forced;
    if (intentionalHumanPickup && (event.before.deckCount ?? 0) === 0) {
      pushUnlock(runtime, progress, unlocks, "endgame-one-last-chest", options);
    }
    if (!wastePickup.forced && getValidCardsForSnapshot(event.before, findSnapshotHuman(event.before, runtime.humanName)).length > 0) {
      pushUnlock(runtime, progress, unlocks, "pickup-loot-goblin", options);
    }
  }
  if (wastePickup.cards.every((card) => card.rank === "A")) {
    pushUnlock(runtime, progress, unlocks, "pickup-ace-ventura", options);
  }
}

function didHumanHoldOpenedFaceDownCard(runtime, state) {
  const human = findSnapshotHuman(state, runtime.humanName);
  return Boolean(human?.hand?.some((card) => (
    card?.id
    && runtime.initialFaceDownIds.has(card.id)
    && runtime.visibleFaceDownIds.has(card.id)
  )));
}

function unlockHandAchievements(runtime, progress, human, unlocks, options) {
  const handCounts = countRanks(human.hand);
  const handRanks = human.hand.map((card) => card.rank);
  if (human.hand.length === 3 && [...handCounts.values()].some((count) => count === 3)) {
    pushUnlock(runtime, progress, unlocks, "hand-destinys-child", options);
  }
  if (hasExactRanks(handRanks, ["A", "3", "3"])) {
    pushUnlock(runtime, progress, unlocks, "hand-donald", options);
  }
  if (hasExactRanks(handRanks, ["A", "3", "3", "7"])) {
    pushUnlock(runtime, progress, unlocks, "hand-1337", options);
  }
  if (REQUIRED_ALL_RANKS.every((rank) => (handCounts.get(rank) ?? 0) >= 1)) {
    pushUnlock(runtime, progress, unlocks, "pickup-oceans-thirteen", options);
  }
}

function unlockVisiblePowerCollectionAchievements(runtime, progress, unlocks, options) {
  if (runtime.visiblePowerCardIdsByRank["10"].size >= 4) {
    pushUnlock(runtime, progress, unlocks, "power-i-want-to-believe", options);
  }
  if (runtime.visiblePowerCardIdsByRank["2"].size >= 4) {
    pushUnlock(runtime, progress, unlocks, "power-toivo-luck", options);
  }
}

function observeHumanVisiblePowerCards(runtime, state) {
  const human = getHumanPlayerSnapshot(state);
  if (!human) {
    return;
  }

  for (const card of [...human.hand, ...human.faceUp]) {
    observePowerCard(runtime, card);
  }
  for (const card of human.faceDown) {
    if (card?.id && runtime.visibleFaceDownIds.has(card.id)) {
      observePowerCard(runtime, card);
    }
  }
}

function observePowerCard(runtime, card) {
  if (!card?.id || !POWER_RANKS.has(card.rank)) {
    return;
  }
  runtime.visiblePowerCardIdsByRank[card.rank].add(card.id);
}

function didHumanCauseFourKindClear(event) {
  if (event.after.playStack?.length !== 0 || !event.card?.rank) {
    return false;
  }
  if (event.card.rank === "10") {
    return false;
  }
  const stack = event.before.playStack ?? [];
  if (stack.length < 3) {
    return false;
  }
  return stack.slice(0, 3).every((card) => card.rank === event.card.rank);
}

function trackSneak100CpuPlay(runtime, event) {
  clearSneak100CpuSetup(runtime);
  const rank = event.card?.rank ?? null;
  if (!rank) {
    resetSneak100CpuTurn(runtime);
    return;
  }

  if (runtime.sneak100CpuTurnRank === rank) {
    runtime.sneak100CpuTurnCardCount += 1;
  } else {
    runtime.sneak100CpuTurnRank = rank;
    runtime.sneak100CpuTurnCardCount = 1;
  }

  if (event.after.playStack?.length === 0) {
    resetSneak100CpuTurn(runtime);
    return;
  }
  if (event.after.currentPlayerName !== event.playerName) {
    maybeFinalizeSneak100CpuSetup(runtime, event);
    resetSneak100CpuTurn(runtime);
  }
}

function maybeFinalizeSneak100CpuSetup(runtime, event) {
  clearSneak100CpuSetup(runtime);
  const rank = runtime.sneak100CpuTurnRank;
  const stack = event.after.playStack ?? [];
  if (
    rank
    && runtime.sneak100CpuTurnCardCount === 3
    && stack.length >= 3
    && stack.slice(0, 3).every((card) => card.rank === rank)
  ) {
    runtime.sneak100CpuSetupRank = rank;
  }
}

function didHumanStealCpuFourKindClear(runtime, event) {
  const stack = event.before.playStack ?? [];
  return Boolean(
    runtime.sneak100CpuSetupRank
    && runtime.sneak100CpuSetupRank === event.card?.rank
    && stack.length >= 3
    && stack.slice(0, 3).every((card) => card.rank === runtime.sneak100CpuSetupRank)
  );
}

function clearSneak100CpuSetup(runtime) {
  runtime.sneak100CpuSetupRank = null;
}

function resetSneak100CpuTurn(runtime) {
  runtime.sneak100CpuTurnRank = null;
  runtime.sneak100CpuTurnCardCount = 0;
}

function startHumanTurnChain(runtime) {
  if (!runtime.humanTurnChainActive) {
    runtime.humanTurnChainActive = true;
    runtime.humanTurnChainPlayedRanks.clear();
    runtime.humanTurnChainPlayedCardCount = 0;
    runtime.fourKindClearStreak = 0;
    runtime.binaryMeltdownTenStreak = 0;
    runtime.fourKind67RanksInTurnChain.clear();
    resetSteamrollingTurnChain(runtime);
  }
}

function endHumanTurnChain(runtime) {
  runtime.humanTurnChainActive = false;
  runtime.humanTurnChainPlayedRanks.clear();
  runtime.humanTurnChainPlayedCardCount = 0;
  runtime.fourKindClearStreak = 0;
  runtime.binaryMeltdownTenStreak = 0;
  runtime.fourKind67RanksInTurnChain.clear();
  runtime.lastChanceCardId = null;
  resetChanceDrawStreak(runtime);
  resetSteamrollingTurnChain(runtime);
  resetFaceDownWrapTurnChain(runtime);
}

function resetChanceDrawStreak(runtime) {
  runtime.successfulChanceDrawStreak = 0;
}

function setSteamrollingTargets(runtime, human) {
  runtime.steamrollingFaceUpTargetIds = new Set((human?.faceUp ?? []).map(getCardId).filter(Boolean));
  resetSteamrollingTurnChain(runtime);
}

function resetSteamrollingTurnChain(runtime) {
  runtime.steamrollingFaceUpPlayedIds.clear();
}

function trackSteamrollingPlay(runtime, event) {
  if (event.sourceZone !== "faceUp" || !event.card?.id) {
    return;
  }
  if (runtime.steamrollingFaceUpTargetIds.has(event.card.id)) {
    runtime.steamrollingFaceUpPlayedIds.add(event.card.id);
  }
}

function resetFaceDownWrapTurnChain(runtime) {
  runtime.openedFaceDownIdsInTurnChain.clear();
  runtime.playedFaceDownIdsInTurnChain.clear();
}

function trackFaceDownWrapPlay(runtime, event) {
  const cardId = event.card?.id ?? null;
  if (!cardId || !runtime.initialFaceDownIds.has(cardId)) {
    return;
  }
  if (event.sourceZone === "faceDown" || runtime.openedFaceDownIdsInTurnChain.has(cardId)) {
    runtime.playedFaceDownIdsInTurnChain.add(cardId);
  }
}

function hasCompleteSteamrollingChain(runtime) {
  return runtime.humanTurnChainActive
    && runtime.steamrollingFaceUpTargetIds.size === 3
    && isSubsetOf(runtime.steamrollingFaceUpTargetIds, runtime.steamrollingFaceUpPlayedIds);
}

function hasCompleteFaceDownWrapChain(runtime) {
  return runtime.humanTurnChainActive
    && runtime.initialFaceDownIds.size === 3
    && isSubsetOf(runtime.initialFaceDownIds, runtime.playedFaceDownIdsInTurnChain);
}

function isSubsetOf(expectedIds, actualIds) {
  for (const id of expectedIds) {
    if (!actualIds.has(id)) {
      return false;
    }
  }
  return true;
}

function pushUnlock(runtime, progress, unlocks, id, options = {}) {
  const achievement = getAchievementById(id);
  if (!achievement || progress.unlocked[id]) {
    return false;
  }

  const record = {
    id,
    category: achievement.category,
    unlockedAt: options.now ?? new Date().toISOString(),
    gameLog: createEmptyStoredGameLog(),
    pendingGameId: null
  };
  progress.unlocked[id] = record;
  unlocks.push({ achievement, record });
  return true;
}

function getValidCardsForSnapshot(snapshot, player) {
  if (!snapshot || !player) {
    return [];
  }
  return getActiveZoneCards(player).filter((card) => isCardLegalInSnapshot(snapshot, player, card));
}

function isCardLegalInSnapshot(snapshot, player, card) {
  const activeCards = getActiveZoneCards(player);
  if (!card || !activeCards.some((candidate) => candidate.id === card.id)) {
    return false;
  }
  const playStack = snapshot.playStack ?? [];
  if (playStack.length === 0) {
    return true;
  }
  const topCard = playStack[0];
  if (snapshot.nextCardMustBeSameRank) {
    return card.rank === topCard.rank;
  }
  if (POWER_RANKS.has(card.rank)) {
    return true;
  }
  return getRankValue(card.rank) >= getRankValue(topCard.rank);
}

function getActiveZoneCards(player) {
  if (!player) {
    return [];
  }
  if (player.hand?.length > 0) {
    return player.hand;
  }
  if (player.faceUp?.length > 0) {
    return player.faceUp;
  }
  if (player.faceDown?.length > 0) {
    return player.faceDown;
  }
  return [];
}

function getRankValue(rank) {
  if (rank === "2") {
    return 2;
  }
  if (rank === "10") {
    return 10;
  }
  if (rank === "J") {
    return 11;
  }
  if (rank === "Q") {
    return 12;
  }
  if (rank === "K") {
    return 13;
  }
  if (rank === "A") {
    return 14;
  }
  return Number.parseInt(rank, 10) || 0;
}

function getSetupCardStrength(card) {
  if (card?.rank === "10") {
    return 100;
  }
  if (card?.rank === "2") {
    return 99;
  }
  return getRankValue(card?.rank);
}

function hasUnderdogReadySetup(human) {
  const hand = human?.hand ?? [];
  const faceUp = human?.faceUp ?? [];
  if (hand.length !== 3 || faceUp.length !== 3) {
    return false;
  }

  const strongestFaceUp = Math.max(...faceUp.map(getSetupCardStrength));
  const weakestHand = Math.min(...hand.map(getSetupCardStrength));
  return strongestFaceUp <= weakestHand;
}

function getHumanPlayerSnapshot(stateOrSnapshot) {
  return stateOrSnapshot?.players?.find((player) => player.role === "human") ?? null;
}

function getCpuPlayerSnapshot(stateOrSnapshot) {
  return stateOrSnapshot?.players?.find((player) => player.role === "cpu") ?? null;
}

function findSnapshotHuman(snapshot, humanName) {
  return snapshot?.players?.find((player) => player.name === humanName) ?? getHumanPlayerSnapshot(snapshot);
}

function findSnapshotPlayer(snapshot, playerName) {
  return snapshot?.players?.find((player) => player.name === playerName) ?? null;
}

function incrementAchievementWinStreak(progress) {
  const aggregate = progress.aggregate ?? createDefaultAchievementProgress().aggregate;
  progress.aggregate = aggregate;
  const nextWinStreak = normalizeWinStreakCount(aggregate.winStreak) + 1;
  aggregate.winStreak = nextWinStreak;
  aggregate.bestWinStreak = Math.max(normalizeWinStreakCount(aggregate.bestWinStreak), nextWinStreak);
  return nextWinStreak;
}

function resetAchievementWinStreak(progress) {
  const aggregate = progress.aggregate ?? createDefaultAchievementProgress().aggregate;
  progress.aggregate = aggregate;
  const previousWinStreak = normalizeWinStreakCount(aggregate.winStreak);
  aggregate.bestWinStreak = Math.max(normalizeWinStreakCount(aggregate.bestWinStreak), previousWinStreak);
  aggregate.winStreak = 0;
  return previousWinStreak !== 0;
}

function updateAchievementDailyStreak(progress, nowValue) {
  const aggregate = progress.aggregate ?? createDefaultAchievementProgress().aggregate;
  progress.aggregate = aggregate;

  const completedDate = getLocalCalendarDateKey(nowValue);
  const previousDate = normalizeCalendarDateKey(aggregate.lastCompletedGameDate);
  const previousStreak = normalizeDailyStreakCount(aggregate.dailyStreak);
  if (completedDate === previousDate) {
    aggregate.dailyStreak = previousStreak;
    aggregate.bestDailyStreak = Math.max(normalizeDailyStreakCount(aggregate.bestDailyStreak), previousStreak);
    aggregate.lastCompletedGameDate = previousDate;
    return { count: previousStreak, counted: false };
  }

  const nextStreak = previousDate && getCalendarDateOrdinal(completedDate) === getCalendarDateOrdinal(previousDate) + 1
    ? previousStreak + 1
    : 1;
  aggregate.dailyStreak = nextStreak;
  aggregate.bestDailyStreak = Math.max(normalizeDailyStreakCount(aggregate.bestDailyStreak), nextStreak);
  aggregate.lastCompletedGameDate = completedDate;
  return { count: nextStreak, counted: true };
}

function getLocalCalendarDateKey(value) {
  const date = value instanceof Date
    ? new Date(value.getTime())
    : value
      ? new Date(value)
      : new Date();
  const validDate = Number.isNaN(date.getTime()) ? new Date() : date;
  const year = validDate.getFullYear();
  const month = String(validDate.getMonth() + 1).padStart(2, "0");
  const day = String(validDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getCalendarDateOrdinal(dateKey) {
  const [year, month, day] = dateKey.split("-").map((part) => Number.parseInt(part, 10));
  return Math.floor(Date.UTC(year, month - 1, day) / MS_PER_DAY);
}

function getDrawDeckCount(stateOrSnapshot) {
  if (Array.isArray(stateOrSnapshot?.deck)) {
    return stateOrSnapshot.deck.length;
  }
  return Math.max(0, Number.parseInt(stateOrSnapshot?.deckCount ?? 0, 10) || 0);
}

function countTotalCards(player) {
  if (!player) {
    return 0;
  }
  return (player.hand?.length ?? 0) + (player.faceUp?.length ?? 0) + (player.faceDown?.length ?? 0);
}

function countRanks(cards) {
  const counts = new Map();
  for (const card of cards ?? []) {
    if (card?.rank) {
      counts.set(card.rank, (counts.get(card.rank) ?? 0) + 1);
    }
  }
  return counts;
}

function countRank(cards, rank) {
  return (cards ?? []).reduce((count, card) => count + (card?.rank === rank ? 1 : 0), 0);
}

function hasExactRanks(actualRanks, expectedRanks) {
  if (!Array.isArray(actualRanks) || actualRanks.length !== expectedRanks.length) {
    return false;
  }

  return [...actualRanks].sort().join("|") === [...expectedRanks].sort().join("|");
}

function copyAchievementCard(card) {
  if (!card) {
    return null;
  }
  return {
    id: card.id,
    suit: card.suit,
    rank: card.rank
  };
}

function copyAchievementEvent(achievement) {
  if (!achievement?.id) {
    return null;
  }

  return {
    id: achievement.id,
    title: achievement.title,
    summary: achievement.summary,
    category: achievement.category,
    unlockedAt: achievement.unlockedAt ?? null
  };
}

function getCardId(card) {
  return card?.id ?? null;
}

function persistNormalizedAchievementProgress(storage, normalized, options = {}) {
  const raw = JSON.stringify(normalized);
  if (options.expectedRaw === raw) {
    return true;
  }
  storage.setItem(ACHIEVEMENT_STORAGE_KEY, raw);
  return true;
}

function createEmptyStoredGameLog() {
  return {
    savedAt: EMPTY_STORED_GAME_LOG.savedAt,
    events: []
  };
}
